<template>
  <div>
    <FilePopup
      v-if="isFilePriview"
      v-bind:filedata="filePriviewData"
      @closePopup="closePopup"
    ></FilePopup>

    <!-- wrap -->
    <div class="sm_star" v-if="!isFilePriview">
      <!-- header -->
      <div class="sm_header">
        <h1>{{ $t("1455") }}</h1>
        <button class="back_btn" @click="$router.go(-1)">
          <span>back btn</span>
        </button>
        <button
          class="upload_btn"
          @click="askForRegister"
          :disabled="isDisabled"
        >
          <span>{{ $t("1456") }}</span>
        </button>
      </div>
      <!-- //header -->

      <!-- content -->
      <div class="sm_wrap">
        <div class="write_wrap">
          <!-- tag -->
          <div class="write_tag">
            <div class="tag_form">
              <button type="button" class="tag_btn">{{ $t("1457") }}</button>
              <span
                class="mr-10 txt"
                v-for="(tag, i) in form.tags"
                :key="i"
                style="
                  background: #f4f5f6;
                  padding: 2px 3px;
                  font-size: 12px;
                  color: #313d4b;
                "
              >
                {{ tag.name }}
                <span @click="removeTag(i)" class="p-5 cursor-pointer">x</span>
              </span>
              <input
                class="txt no-border"
                :placeholder="form.tags.length == 0 ? $t('1457') : ''"
                @keyup="searchTags($event.target.value)"
                @keyup.enter.native="createTags($event.target.value)"
                id="tagInput"
              />
              <!-- <span class="txt">{{ $t("1457") }}</span> -->
            </div>
            <ul v-if="tags && tags.length" class="tag-ul">
              <li
                v-for="tag in tags"
                :key="tag.id"
                @click="addTag(tag)"
                class="cursor-pointer"
              >
                {{ tag.name }}
              </li>
            </ul>
            <p class="t-helper mgl-7 mgr-7 pdt-2 min-h-23 t-color-gray0">
              {{ $t("1458") }}
            </p>
          </div>

          <!-- write -->
          <div class="write_form" :class="{'write_form__attachment': form.contents.images.length > 0}">
            <textarea
              ref="textarea1"
              :placeholder="$t('1460')"
              v-model="form.contents.body"
            ></textarea>
          </div>

          <div class="attachment-wrapper" v-if="form.contents.images.length > 0">
            <div
              class="post-img position-relative mgr-20"
              v-for="(img, i) in form.contents.images"
              :key="i"
            >
              <img
                @click="priviewFiel(img)"
                :src="img.resourceUri"
                :alt="img.originalName"
                style="height: 100px; object-fit: cover"
              />
              <span
                @click="form.contents.images.splice(i, 1)"
                class="remove-img remove-image-new position-absolute t-color-white"
                ><img src="/images/close.svg" style="width: 20px"
              /></span>
            </div>

            <div
              class="post-video position-relative mgr-20"
              v-if="form.contents.video && form.contents.video.resourceUri"
              style="width: 100px; position: relative"
            >
              <video-player
                class="video-player-box"
                :options="{
                  muted: true,
                  language: 'en',
                  playbackRates: [0.7, 1.0, 1.5, 2.0],
                  sources: [
                    {
                      type: form.contents.video.contentType,
                      src: form.contents.video.resourceUri,
                    },
                  ],
                  height: 100,
                  width: 100,
                }"
                :playsinline="true"
              />
              <div
                @click="priviewFiel(form.contents.video)"
                style="
                  position: absolute;
                  background-color: transparent;
                  width: 100px;
                  height: 100px;
                  margin-top: -88px;
                  z-index: 999;
                "
              ></div>
              <span
                @click="resetVideo"
                class="remove-img remove-image-new position-absolute t-color-white"
                ><img
                  src="/images/closeNew.svg"
                  style="width: 20px; height: 20px"
              /></span>
            </div>
          </div>
          <!-- //write -->

          <div class="comment_box write">
            <div class="comment_area">
              <input
                type="file"
                id="commentFileUpload"
                :accept="allowExt()"
                @change="uploadFile"
                class="d-none"
              />
              <span
                class="material-icons radar-icons picture_btn"
                @click="openFileUpload(true)"
              >
                photo_library
              </span>
              <span
                class="material-icons radar-icons picture_btn"
                @click="openFileUpload(false)"
              >
                videocam
              </span>

              <!-- <p class="cursor-pointer tail_txt">{{ $t("1461") }}</p> -->
            </div>
          </div>
        </div>
      </div>
      <!-- //content -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import socialApi from "@/api/socialApi.js";
import FilePopup from "./FilePopup";
// require styles
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import _ from "lodash";

export default {
  components: {
    videoPlayer,
    FilePopup,
  },
  data() {
    return {
      form: {
        category: null,
        status: null,
        boardType: null,
        notifyType: null,
        contents: {
          type: null,
          subject: null,
          body: null,
          linkName: null,
          linkUrl: null,
          images: [],
          video: {
            chunkCount: 0,
            contentType: null,
            duration: 0,
            height: 0,
            id: null,
            name: null,
            originalName: null,
            resourceUri: null,
            size: 0,
            subFileResourceUri: [],
            width: 0,
          },
        },
        fixed: false,
        tags: [],
      },
      tags: [],
      // check if upload is set ti image or video
      uploadTypeImg: true,
      isDisabled: false,
      filePriviewData: [],
      isFilePriview: false,
      boardId: null,
      boardData: null,
    };
  },

  beforeCreate() {
    this.boardId = this.$route.query.bId;
  },

  beforeMount() {
    this.boardId = this.$route.query.bId;
    this.setDetail();
    this.findBoardData();

    socialApi
      .fetchMember()
      .then((response) => {
        this.mamberData = response.data.data;
      })
      .catch((err) => {
        $state.error();
      });

    // socialApi.bordList({}).then(response => {
    //           this.boards = response.data.data.filter(arr=>arr.boardAuth == true);

    //           socialApi
    //           .fetchMember()
    //           .then(response => {
    //             this.mamberData = response.data.data;
    //             let myId = this.mamberData.responsibilityId
    //             console.log('myId',myId)

    //             this.boardData = this.boards.find(arr=>arr.identifier == this.$route.query.board);
    //             console.log('this.boardData ',this.boardData)

    //           })
    //           .catch(err => {
    //             $state.error();
    //           });

    //         })
    //         .catch(err => {
    //           $state.error();
    //         });
  },

  mounted() {
    this.$nextTick(() => this.$refs.textarea1.focus());
  },

  methods: {
    findBoardData() {
      socialApi
        .boardAuth(this.boardId)
        .then((response) => {
          this.boardData = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    priviewFiel(file) {
      this.filePriviewData = file;
      this.isFilePriview = true;
      console.log("file priview data", this.filePriviewData);
    },
    closePopup() {
      this.filePriviewData = Array();
      this.isFilePriview = false;
    },
    resetVideo() {
      this.form.contents.video = {
        chunkCount: 0,
        contentType: null,
        duration: 0,
        height: 0,
        id: null,
        name: null,
        originalName: null,
        resourceUri: null,
        size: 0,
        subFileResourceUri: [],
        width: 0,
      };
    },
    uploadFile(evt) {
      if (!evt.target.files[0]) return;

      // validate video and/or audio
      if (!this.videoAudioSelected()) return;

      // check if image selected then count number of image selected
      if (!this.invalidCountImg()) return;

      // check if user try to add more than 1 video
      if (!this.invalidVideoCount()) return;

      this.$showLoading();
      socialApi
        .upload(evt.target.files[0])
        .then((response) => {
          // check if user uploaded an image
          if (this.uploadTypeImg)
            this.form.contents.images.push(response.data.data[0]);
          else this.form.contents.video = response.data.data[0];

          this.$hideLoading();
        })
        .catch((err) => {
          this.$hideLoading();
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    videoAudioSelected() {
      if (
        (this.uploadTypeImg &&
          this.form.contents.video &&
          this.form.contents.video.resourceUri) ||
        (!this.uploadTypeImg && this.form.contents.images.length)
      ) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1473"),
          accept: this.$t("1476"),
        });
        return false;
      }
      return true;
    },
    invalidCountImg() {
      if (this.uploadTypeImg && this.form.contents.images.length >= 5) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1469"),
          accept: this.$t("1470"),
        });
        return false;
      }
      return true;
    },
    invalidVideoCount() {
      if (
        !this.uploadTypeImg &&
        this.form.contents.video &&
        this.form.contents.video.resourceUri
      ) {
        this.$alert({
          content: this.$t("1471"),
          accept: this.$t("1472"),
        });
        return false;
      }
      return true;
    },
    openFileUpload(allowImg) {
      this.uploadTypeImg = allowImg;
      setTimeout(() => {
        document.getElementById("commentFileUpload").click();
      }, 0);
    },
    allowExt() {
      return this.uploadTypeImg ? "image/jpeg,image/png" : "video/mp4";
    },
    register() {
      if (!this.boardData) {
        this.findBoardData();
      }
      if (this.boardData.userBbsToDayAuth) {
        this.$showLoading();
        let action = this.form.id
          ? socialApi.updatePost(this.form.id, this.form, this.boardId)
          : socialApi.register(this.form, this.boardId);

        action
          .then((response) => {
            this.$hideLoading();
            this.isDisabled = true;
            this.$router.push(
              "/socialLearning/" +
                response.data.data.id +
                "?bId=" +
                this.boardId +
                "&a=1"
            );
          })
          .catch((err) => {
            this.$error({ content: err.errMsg }).then(() => {});
          });
      } else {
        this.$alert({
          //title: this.$t('779'), //가입 승인 대기 상태입니다.
          content: this.$t("3064"),
          accept: this.$t("3065"),
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    setDetail() {
      if (!this.$route.params.postId) return;

      this.$showLoading();
      socialApi
        .socialDetails(this.$route.params.postId, this.boardId)
        .then((response) => {
          Object.assign(this.form, response.data.data);
          this.$hideLoading();
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    askForRegister() {
      // check if No content exists
      if (!this.form.contents.body) {
        // show alert
        this.$alert({
          //title: this.$t("72"), // 학습을 중단한 강의입니다.
          content: this.$t("1883"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
          accept: this.$t("1884"), // 확인
        });
        return;
      }
      if (this.form.contents.body.length < 50) {
        // show alert
        this.$alert({
          //title: this.$t("72"), // 학습을 중단한 강의입니다.
          content: this.$t("S10042"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
          accept: this.$t("1884"), // 확인
        });
        return;
      }

      this.isDisabled = true;

      // check if add or update
      // if (this.form.id) {
      //   this.$confirm({
      //     // title: this.$t('72'),   // 학습을 중단한 강의입니다.
      //     content: this.$t("1450"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
      //     accept: this.$t("1451"), // 확인
      //     cancel: this.$t("1447") //'TODO-취소'
      //   })
      //     .then(() => {
      //       this.register();
      //     })
      //     .catch(() => {});
      // } else {
      this.register();
      // }
    },
    searchTags: _.throttle(function (str) {
      //console.log('I get fired every two seconds!'
      // console.log('Alread y tag ppp',this.form.tags)
      if (this.form.tags.length == 0) {
        socialApi
          .searchTags(str.trim())
          .then((response) => {
            this.tags = response.data.data;
            if (str.indexOf(" ") >= 0 && this.tags.length < 1) {
              socialApi
                .createTags({ name: str.trim() })
                .then((response1) => {
                  // console.log('tag response',response1)
                  let rs = response1.data.data;
                  if (rs.id) {
                    this.searchTags(str);
                  }
                })
                .catch((err) => {
                  this.$error({ content: err.errMsg }).then(() => {});
                });
            }
            // if(this.tags.length < 1 ){
            //    str
            // }
          })
          .catch((err) => {
            this.$error({ content: err.errMsg }).then(() => {});
          });
      } else {
        if (str.indexOf(" ") >= 0) {
          socialApi
            .createTags({ name: str.trim() })
            .then((response1) => {
              // console.log('tag response',response1)
              let rs = response1.data.data;
              if (rs.id) {
                socialApi
                  .searchTags(str.trim())
                  .then((response) => {
                    this.tags = response.data.data;
                  })
                  .catch((err) => {
                    this.$error({ content: err.errMsg }).then(() => {});
                  });
              }
            })
            .catch((err) => {
              this.$error({ content: err.errMsg }).then(() => {});
            });
        }
      }
    }, 2000),
    createTags(str) {
      alert(str);
    },
    // searchTags(str) {
    //   socialApi
    //     .searchTags(str.trim())
    //     .then(response => {
    //       this.tags = response.data.data;
    //     })
    //     .catch(err => {
    //       this.$error({ content: err.errMsg }).then(() => {});
    //     });
    // },
    addTag(tag) {
      this.form.tags.push(tag);
      // console.log('jkhkjhjkhkjhkjh',tag)
      this.tags = [];
      document.getElementById("tagInput").value = null;
    },
    removeTag(index) {
      this.form.tags.splice(index, 1);
    },
  },
};
</script>

<style scoped >
.post-img span {
  padding: 5px;
  /* border: 1px solid #c8c8c8; */
  cursor: pointer;
}
.remove-image-new {
  top: -16px;
  right: -16px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #fff;
  color: #fff;
  line-height: 0px;
}
.post-img {
  width: 100px;
  display: inline-block;
}
.post-img img {
  width: 100px;
}

.d-none {
  display: none;
}
.tag-ul {
  position: relative;
  z-index: 1;
  margin-left: 20px;
  width: 100%;
}
.tag-ul li {
  background-color: #c8c8c8;
  padding: 10px;
  border-bottom-color: #000;
}

.p-5 {
  padding: 5px !important;
}

.mr-10 {
  margin-right: 10px !important;
}

.cursor-pointer {
  cursor: pointer;
}
.no-border {
  border: none;
}
/* reset */
.sm_star * {
  margin: 0;
  padding: 0;
  font-family: "Roboto", Arial, dotum, sans-serif;
  font-weight: normal;
  font-size: 13px;
  color: #222;
}
ol,
ul,
li {
  list-style: none;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}
th {
  font-weight: normal;
}
form,
fieldset,
iframe {
  display: block;
  border: 0;
}
img,
button {
  border: none;
  vertical-align: middle;
}
hr {
  height: 0;
  display: none;
}
i,
em,
address {
  font-style: normal;
}
label,
button {
  cursor: pointer;
}
blockquote,
q {
  quotes: none;
}
caption,
.hide {
  visibility: hidden;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -9999em;
}
legend {
  overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -100%;
  white-space: nowrap;
  z-index: -1;
}
input[type="text"],
input[type="password"],
input[type="email"],
input[type="search"],
input[type="image"],
input[type="tel"],
textarea {
  -webkit-appearance: none;
  -webkit-border-radius: 0;
}
input:focus {
  outline: none;
}
::-webkit-input-placeholder {
  color: #999;
}
::-moz-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}
::-webkit-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}
a {
  color: #222;
  text-decoration: none;
}
a:link,
a:visited {
  text-decoration: none;
}
button {
  display: inline-block;
  background: none;
  border: none;
  outline: none;
}
::selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

/* header */
.sm_star {
  position: relative;
  margin: 0 auto;
}
.sm_star.backBg:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 997;
}
.sm_header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #e9e9e9;
  z-index: 999;
  background-color: #fff;
  box-shadow: none;
}
.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
  padding-top: 12px;
}
.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}
.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}
.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}
.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}
.sm_header .search_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/search_btn.svg") center center no-repeat;
  background-size: 22px auto;
}
.sm_header .search_btn span {
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .back_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/back_btn.png") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .more_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/more_btn.png") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .more_box {
  position: absolute;
  right: 15px;
  top: 45px;
  width: 80px;
  z-index: 10;
}
.sm_header .close_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/close_btn.svg") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.more_box {
  display: inline-block;
  padding: 15px 20px;
  background: #fff;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);
  border-radius: 4px;
  display: none;
}
.more_box a {
  display: block;
  color: #333;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  margin-bottom: 5px;
}
.more_box a:nth-last-child(1) {
  margin-bottom: 0;
}

.sm_header .upload_btn {
  width: 80px;
  height: 55px;
  line-height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  font-size: 15px;
  color: #2d6dcc;
}
.sm_header .upload_btn span {
  font-size: 15px;
  color: #2d6dcc;
  font-weight: 500;
}

.search_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
  display: none;
}
.search_box .search_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/close_btn.svg") center center no-repeat;
  background-size: 22px auto;
  text-indent: -9999px;
}
.search_box .search_form {
  position: absolute;
  left: 60px;
  top: 12px;
  border: 0;
  background: #fff;
  font-size: 18px;
  color: #212121;
  height: 30px;
  width: calc(100% - 125px);
}

/* layer img */
.layer_img {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
}
.layer_img .layer_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  z-index: 999;
}
.layer_img .layer_close:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(-45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}
.layer_img .layer_close:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}
.layer_img .img_placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}
.layer_img .img {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}
.layer_img .img_placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.layer_img .img img {
  display: inline;
  max-width: 100%;
}

/* layer pop */
.layer_pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 999;
  display: none;
}
.layer_con {
  width: 90%;
  max-width: 300px;
  background: #fff;
  box-sizing: border-box;
  padding: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  box-shadow: 0 19px 38px 0 rgba(0, 0, 0, 0.26);
}
.layer_con .layer_txt {
  font-size: 16px;
  color: #818181;
  line-height: 1.5;
}
.layer_con .layer_btn {
  position: relative;
  padding: 30px 0 0 0;
  text-align: right;
}
.layer_con .layer_btn a {
  display: inline-block;
  padding: 5px 15px;
  color: #2d6dcc;
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
}

/* upload */
.upload_wrap {
  position: relative;
  padding: 15px;
}
.upload_list {
  position: relative;
  font-size: 0;
}
.upload_list > li {
  display: inline-block;
  vertical-align: top;
  width: 32%;
  margin-right: 2%;
  margin-bottom: 2%;
}
.upload_list > li:nth-child(3n) {
  margin-right: 0;
}
.upload_list .file {
  position: relative;
  height: 0;
  padding-top: 100%;
}
.upload_list .file > a {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.upload_list .file img,
.upload_list .file video,
.upload_list .file iframe {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.upload_list .file.active a:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(49, 61, 75, 0.3);
}
.upload_list .file .pic {
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #fff;
  background: #2d6dcc;
  font-size: 13px;
  position: absolute;
  right: 10px;
  top: 10px;
  border-radius: 50%;
  z-index: 10;
}

/* user */
.user_box {
  position: relative;
}
.user_box .user_img {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin-right: 15px;
}
.user_box .user_img img {
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.user_box .user_txt {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.user_box .user_txt .name {
  font-size: 14px;
  color: #212121;
}
.user_box .user_txt .date {
  position: relative;
  padding: 2px 0 0 0;
  color: #818181;
  font-size: 14px;
}
.user_box .user_write {
  position: absolute;
  right: 0;
  top: 0;
}
.user_box .user_write > a {
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  background-size: 24px auto !important;
}
.user_box .user_write .write_btn {
  font-size: 12px;
  color: #acb4be;
  padding-top: 28px;
  background: url("/images/write_icon.png") center top no-repeat;
}
.user_box .user_write .write_btn.me {
  background: url("/images/my_write_icon.png") center top no-repeat;
}
.user_box .user_date {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  color: #818181;
}
.user_fixed {
  position: fixed;
  left: 0;
  top: 55px;
  width: 100%;
  height: 75px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 15px;
  z-index: 10;
}

/* style */
.sm_wrap {
  position: relative;
  padding: 55px 0 0 0;
  height: calc(100vh - 56px);
}
.sm_list {
  position: relative;
}
.sm_list.view {
  padding-bottom: 85px;
}
.sm_list.learning {
  padding: 90px 15px 15px 15px;
  background: #f9f9f9;
  position: relative;
}
.sm_list_box {
  position: relative;
}
.sm_list_box > .list_box {
  position: relative;
  margin-bottom: 15px;
}
.sm_list_box > .list_box:nth-last-child(1) {
  margin-bottom: 0;
}
.sm_list .no_data {
  position: relative;
  height: calc(100vh - 210px);
  text-align: center;
  padding: 50px 0 0 0;
  min-height: 300px;
}
.sm_list .no_data .no_img img {
  max-width: 120px;
}
.sm_list .no_data p:nth-child(2) {
  position: relative;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.sm_list .no_data p:nth-child(3) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}
.sm_list.view .list_box {
  margin-bottom: 0;
}

.list_box {
  position: relative;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  padding: 15px;
}
.list_box .user_con {
  padding: 15px 0 0 0;
}
.list_box .user_tag {
  padding: 10px 0 0 0;
}
.list_box .user_opt {
  margin: 20px 0 0 0;
}
.list_box .user_imgList {
  margin: 20px 0 0 0;
}
.user_con {
  position: relative;
  font-size: 14px;
  color: #818181;
  line-height: 1.57;
}
.user_con .em {
  color: #212121;
  margin-right: 5px;
  font-size: 14px;
}
.user_tag {
  position: relative;
  font-size: 0;
}
.user_tag span {
  display: inline-block;
  vertical-align: top;
  margin-right: 5px;
  font-size: 12px;
  color: #313d4b;
  padding: 2px 3px;
  background: #f4f5f6;
  border-radius: 2px;
}
.user_opt {
  position: relative;
  font-size: 12px;
  color: #818181;
}
.user_opt .right {
  position: absolute;
  right: 0;
  top: 0;
  color: #818181;
}
.list_btn {
  position: relative;
  text-align: center;
  font-size: 0;
  border-top: 1px solid #e6eced;
  margin: 15px 0 0 0;
  padding: 10px 0 0 0;
}
.list_btn a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px 0 25px;
  background-size: 17px auto;
  background-position: left center;
  background-repeat: no-repeat;
  margin: 0 5px;
  color: #acb4be;
}
.list_btn a.like {
  background-image: url("/images/like_btn.png");
}
.list_btn a.like.on {
  background-image: url("/images/like_btn_on.png");
}
.list_btn a.reply {
  background-image: url("/images/reply_btn.png");
}
.list_btn a.share {
  background-image: url("/images/share_btn.png");
}
.user_imgList {
  position: relative;
  font-size: 0;
}
.user_imgList a {
  display: inline-block;
  position: relative;
}
.user_imgList a img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}
.user_imgList a.more:before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 1;
}
.user_imgList a.more span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  z-index: 2;
}
.user_imgList > a:nth-child(1) {
  width: 66%;
  height: 0;
  padding-top: 66%;
}
.user_imgList > a:nth-child(2) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  top: 0;
}
.user_imgList > a:nth-child(3) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  bottom: 0;
}
.user_imgList.view a {
  display: block;
  padding-top: 0;
  height: auto;
  position: relative;
  right: auto;
  top: auto;
  width: auto;
  margin-bottom: 10px;
}
.user_imgList.view a img {
  position: relative;
  left: 0;
  top: auto;
  width: auto;
  max-width: 100%;
  height: auto;
  transform: none;
}
.user_imgList.reply {
  margin: 0 0 0 55px;
  white-space: nowrap;
  overflow-x: auto;
}
.user_imgList.reply a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}
.input_file .user_imgList {
  white-space: nowrap;
  overflow-x: auto;
}
.input_file .user_imgList a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}
.user_imgList a.video:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(49, 61, 75, 0.3);
  position: absolute;
  left: 0;
  top: 0;
}
.user_imgList a.video:before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url("/images/play_icon.png") center center no-repeat;
  background-size: 25px auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.reply_wrap {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
}
.reply_wrap > div:nth-last-child(1) {
  margin-bottom: 0;
}
.reply_box {
  position: relative;
  margin-bottom: 15px;
}
.reply_box .user_box .user_date {
  right: 40px;
  color: #a6a6a6;
}
.reply_box .user_box .more_btn {
  width: 22px;
  height: 22px;
  background: url("/images/reply_more_btn.png") center center no-repeat;
  background-size: 22px auto;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-indent: -9999px;
}
.reply_box .user_con {
  padding: 10px 15px 10px 58px;
}
.reply_box .list_btn {
  text-align: left;
  border-top: 0;
  margin: 0;
  padding: 0 0 0 55px;
}
.reply_box > .reply_box {
  padding: 10px 0 0 50px;
}

.comment_box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 50;
  padding: 15px 15px 20px 15px;
  background: #fff;
  box-sizing: border-box;
  border-top: 1px solid #e6eced;
}
.comment_area {
  position: relative;
}
.comment_area button {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-indent: -9999px;
  font-size: 0;
  position: absolute;
  top: 0;
  vertical-align: top;
}
.comment_area .picture_btn {
  font-size: 22px;
  color: #acb4be;
  position: relative;
  margin-right: 24px;
}
.comment_area .video_btn {
  background: url("/images/video_btn.png") center center no-repeat;
  background-size: 22px auto;
  position: relative;
}
.comment_area .comment_btn {
  background: url("/images/comment_btn.png") center center no-repeat;
  background-size: 22px auto;
  right: 0;
}
.comment_area .comment_btn.on {
  background: url("/images/comment_btn_on.png") center center no-repeat;
  background-size: 22px auto;
}
.comment_textarea {
  position: relative;
  vertical-align: top;
  font-size: 14px;
  background: none;
  border: 0;
  width: calc(100% - 130px);
  resize: none;
  outline: none;
  height: 25px;
  margin-top: 14px;
}
.comment_area .tail_txt {
  position: absolute;
  right: 0;
  top: 15px;
  font-size: 14px;
  color: #acb4be;
}

.search_list {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
  min-height: calc(100vh - 85px);
}
.search_list .no_data {
  position: relative;
  text-align: center;
  padding: 30px 0 0 0;
  min-height: 300px;
}
.search_list .no_data p:nth-child(1) {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.search_list .no_data p:nth-child(2) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}

.write_wrap {
  position: relative;
  background: white;
  height: 100%;
}
.write_tag {
  position: relative;
  padding: 15px;
  background: #fff;
  border-bottom: 1px solid #e6eced;
}
.write_tag .tag_tail {
  position: relative;
  padding: 10px 15px 0 15px;
  font-size: 12px;
  color: #acb4be;
}
.write_tag .tag_form {
  position: relative;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid rgba(172, 180, 190, 0.7);
  min-height: 20px;
}
.write_tag .tag_form .tag_btn {
  width: 25px;
  height: 25px;
  font-size: 0;
  text-indent: -9999px;
  background: url("/images/addTag_icon.png") center center no-repeat;
  background-size: 22px auto;
  vertical-align: middle;
  margin-right: 5px;
}
.write_tag .tag_form span.txt {
  font-size: 14px;
  color: #acb4be;
  vertical-align: middle;
  line-height: 1;
}
.write_tag .tag_form span.tag {
  display: inline-block;
  padding: 3px 5px;
  background: #f0f1f2;
  font-size: 14px;
  color: #313d4b;
  vertical-align: middle;
  margin-right: 3px;
  line-height: 1.4;
}
.write_tag .tag_form span.tag.txt {
  color: #313d4b;
  line-height: 1.4;
  background: none;
}
.write_form {
  position: relative;
  padding: 16px;
  background: #fff;
  height: calc(100% - 130px);
}
.write_form__attachment {
  height: calc(100% - 255px);
}
.write_form textarea {
  border: 0;
  background: none;
  font-size: 14px;
  color: #313d4b;
  line-height: 1.57;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  resize: none;
  outline: none;
}

.tag_list {
  position: relative;
}
.tag_list ul {
  position: relative;
}
.tag_list ul li {
  position: relative;
  display: block;
  background: #f9f9f9;
  border-bottom: 1px solid #e6eced;
}
.tag_list ul li span {
  display: block;
  padding: 15px;
}

.input_file {
  position: fixed;
  left: 0;
  bottom: 85px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  z-index: 10;
  background: #fff;
}
.input_file + .write_form textarea {
  min-height: inherit;
  height: calc(100vh - 410px);
}

.edit_wrap {
  position: relative;
  height: calc(100vh - 55px);
  text-align: center;
  overflow-x: hidden;
  overflow-y: auto;
}
.edit_wrap .placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}
.edit_wrap .placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.edit_wrap .edit_file {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}
.edit_wrap .edit_file img {
  display: inline;
  max-width: 100%;
}
.edit_wrap .edit_file .video {
  display: inline-block;
  position: relative;
}
.edit_wrap .edit_file .video:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(49, 61, 75, 0.3);
  position: absolute;
  left: 0;
  top: 0;
}
.edit_wrap .edit_file .video:before {
  content: "";
  display: inline-block;
  width: 50px;
  height: 50px;
  background: url("/images/play_icon.png") center center no-repeat;
  background-size: 50px auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

#textArea {
}

.attachment-wrapper {
  white-space: nowrap;
  overflow-x: auto;
  padding: 15px;

}
</style>
